import config from '../config'
import util from '../util'
import api from '../api'

let app = getApp()


// 微信内置浏览器登录获取商家APPid
var setDataPoint = function(e,data){
  let that = this
  let url = api.dataEventTracking
  let systemInfo = util.getSystemInfoSync()
  let OSType = 0 // (0, “未知”),(1, “安卓系统”),(2, “苹果 iOS”),
  let OSVersion = 0 
  let Source = util.getProgramEnv() // (0, “未知”),(1, “服务器后端埋点，即 API 埋点”),(2, “PC，桌面”),(3, “安卓APP”),(4, “苹果APP”),(5, “微信公众号等 H5”),(6, “微信小程序”),(7, “H5”),(12, “抖音”),
  if(!app) app = getApp()
  let userInfo = {}
  let theaterInfo = {}
  if(app.globalData.iyanyiUser.Id){
    userInfo = app.globalData.iyanyiUser
  }
  if(app.globalData.theaterInfo && app.globalData.theaterInfo.Id){
    theaterInfo = app.globalData.theaterInfo
  }

  if(systemInfo){
    if(systemInfo.systemInfo && systemInfo.systemInfo.system && systemInfo.systemInfo.system.toLowerCase() === 'android'){
      OSType = 1
    }
    if(systemInfo.systemInfo && systemInfo.systemInfo.system && systemInfo.systemInfo.system.toLowerCase() === 'ios'){
      OSType = 2
    }
    OSVersion = systemInfo.systemInfo.sysVersion
  }
  
  let params = {
    City: '',                       // 【选填】埋点记录城市（代码）
    ClientVersion: systemInfo.loginLog.ProductVersion || '0.0.1',             // 【必填】客户端版本
    DevManufacturer: '',            // 【选填】设备制造商
    DevModel: "",                   // 【选填】设备型号
    DeviceId: "",                   // 【选填】设备ID
    Duration: 0,                   // 【必填】页面浏览毫秒数，关闭页面时统计，单位毫秒 ms
    EventDataAddKVObjList:[],
    EventDataAddKV: "",             // 【选填】埋点事件业务数据扩展     
    EventDataKey: 0,                // 【选填】埋点事件业务数据类型(0, “商家”),(1, “演出列表”),(2, “演出”),(3, “演出列表（分销渠道）”),(4, “演出（分销渠道）”),(5, “运营会员日活动详情”),(6, “运营生日活动详情”),(7, “运营节日活动详情”)
    EventDataValue: theaterInfo.Id || "yunyu",            // 【必填】埋点事件业务数据 ID
    EventKeyName: theaterInfo.Name || "云娱智慧",              // 【必填】埋点事件业务数据名称
    EventType: 0,                  // 【必填】埋点触发类型，(0, “浏览”),(1, “点击”),
    HttpRefer: "",                  // 【选填】
    Ip: "0.0.0.0",                        // 【必填】客户机 IP
    Latitude: "",                   // 【选填】定位，纬度
    Longitude: "",                  // 【选填】定位，经度
    NetworkType: 0,                // 【必填】客户机网络环境，(0, “未知”),(1, “WIFI”),(2, “移动网络”),
    OSType: OSType,                      // 【选填】客户运行环境OS类型（OSType 与 Ostype 两个是同一个数据），(0, “未知”),(1, “安卓系统”),(2, “苹果 iOS”),
    OSVersion: OSVersion,                  // 【选填】OS版本号（OSVersion 与 Osversion 两个是同一个数据），如 Android 9，IOS 13
    Ostype: 0,                      // 
    Osversion: "",                  //
    Province: "",                   // 【选填】埋点记录省份（代码）
    ReferPage: "",                  // 【选填】所浏览页面的上一个页面的标识号
    Source: Source,                     // 【必填】埋点数据渠道来源，(0, “未知”),(1, “服务器后端埋点，即 API 埋点”),(2, “PC，桌面”),(3, “安卓APP”),(4, “苹果APP”),(5, “微信公众号等 H5”),(6, “微信小程序”),(7, “H5”),
    TriggerId: "",                 // 【必填】埋点触发器ID，如页面上按钮绑定的埋点触发ID
    UpTime: new Date().getTime(),                     // 【必填】埋点触发：客户端上传时间，毫秒时间戳
    UserAge: 0,                     // 【选填】用户年龄
    UserGender: userInfo.Gender? (userInfo.Gender && userInfo.Gender === '男') ? 1 : (userInfo.Gender && userInfo.Gender === '女') ? 2 : 0 : 0,                  // 【选填】用户性别，1=男，2=女
    UserId: userInfo.Id,                     // 【选填】用户ID
    UserPhone: userInfo.PhoneNumber,                  // 【选填】用户手机号
    UserProps: ""                   // 【选填】其它属性，格式 [ { "K": "xx", "V": “xx” }， { "K": "xx", "V": “xx” } ]
  }
  if(data){
    for (let t in params) {
      if (data.hasOwnProperty(t)) {
        params[t] = data[t]
      }
    }
  }
  
  return new Promise((resolve, reject) => {
    util.requestData(url,params,'post').then(res=>{
      resolve(res)
    }).catch(err =>{
      reject(err)
    })
  })
  
}

module.exports = {
  setDataPoint
}
